import "../../css/GlobalStyles.css";
import { Icon } from "@iconify/react";
import React, { memo, ReactNode, useState } from "react";
import { Event, EventType, MediaAspectRatio } from "@markit/common.types";
import { Colors } from "../../utils/colors";
import EventItemImage from "../DisplayItem/EventItem/EventItemImage";

type MediaPreviewItemProps = {
  mediaUrl: string;
  index: number;
  size: number;
  onSelectMedia: (index: number) => void;
  onRemoveMedia?: (index: number) => void;
  dragHandleProps?: React.HTMLAttributes<HTMLDivElement>;
  altImage?: ReactNode;
  aspectRatio?: MediaAspectRatio;
};

// For displaying a single media item that can be selected and removed
const MediaPreviewItem = memo(function MediaPreviewItemFn(
  props: MediaPreviewItemProps
) {
  const {
    mediaUrl,
    index,
    size,
    onSelectMedia,
    onRemoveMedia,
    dragHandleProps,
    altImage,
    aspectRatio,
  } = props;
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const styles = {
    container: {
      overflow: "visible" as const,
      position: "relative" as const,
      flexShrink: 0,
    },
    removeButton: {
      position: "absolute" as const,
      top: 5,
      right: 5,
      width: 18,
      height: 18,
      borderRadius: 100,
      backgroundColor: Colors.BLACK,
      cursor: "pointer",
    },
  };

  return (
    <div
      key={`${mediaUrl}-${index}`}
      style={styles.container}
      onMouseEnter={(e) => {
        e.currentTarget.style.opacity = "0.7";
        setHoveredIndex(index);
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.opacity = "1";
        setHoveredIndex((current) => (current === index ? null : current));
      }}
      onClick={() => onSelectMedia?.(index)}
      {...(dragHandleProps as React.HTMLAttributes<HTMLDivElement>)}
    >
      {altImage || (
        <EventItemImage
          item={
            {
              eventType: EventType.MARKIT,
              mediaURLs: [mediaUrl],
            } as Event
          }
          size={size}
          aspectRatio={aspectRatio}
          scaleImage
          containerStyles={dragHandleProps ? { cursor: "move" } : {}}
        />
      )}
      {onRemoveMedia && hoveredIndex === index ? (
        <div
          className="Centering"
          style={styles.removeButton}
          onClick={(e) => {
            e.stopPropagation();
            onRemoveMedia(index);
          }}
        >
          <Icon icon="ion:close" height={10} style={{ color: Colors.WHITE }} />
        </div>
      ) : null}
    </div>
  );
});

export default MediaPreviewItem;
